import { ArrowUp } from "lucide-react";
import Logo from "@/components/Logo";
import { scrollToId } from "@/lib/scroll";

const SERVICES = [
  "Full Refurbishments",
  "Painting & Decorating",
  "Bathroom Installations",
  "Kitchen Installations",
  "End of Tenancy Cleaning",
];

const LINKS = [
  { id: "services", label: "Services" },
  { id: "projects", label: "Projects" },
  { id: "about", label: "About" },
  { id: "contact", label: "Contact" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#121212] border-t border-white/10">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 pt-16 md:pt-24 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-5">
            <Logo markSize={40} />
            <p className="mt-6 font-serif italic text-2xl text-[#c5832b]">
              "Helping achieve the space you love"
            </p>
            <p className="mt-4 max-w-xs text-sm text-[#a3a3a3] leading-relaxed">
              Family-owned property refurbishment — every trade, one team, from
              first coat to final clean.
            </p>
          </div>

          <div className="md:col-span-2">
            <p className="text-xs uppercase tracking-[0.2em] text-[#a3a3a3] mb-5">Explore</p>
            <ul className="space-y-3">
              {LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-link-${l.id}`}
                    onClick={() => scrollToId(l.id)}
                    className="text-sm text-[#f5f5f0]/80 hover:text-[#c5832b] transition-colors duration-300"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.2em] text-[#a3a3a3] mb-5">Services</p>
            <ul className="space-y-3">
              {SERVICES.map((s) => (
                <li key={s}>
                  <button
                    data-testid={`footer-service-${s.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                    onClick={() => scrollToId("services")}
                    className="text-sm text-left text-[#f5f5f0]/80 hover:text-[#c5832b] transition-colors duration-300"
                  >
                    {s}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="text-xs uppercase tracking-[0.2em] text-[#a3a3a3] mb-5">Get in touch</p>
            <p className="text-sm text-[#f5f5f0]/80">07792724398</p>
            <p className="text-sm text-[#f5f5f0]/80 mt-2 break-all">
              preecerefurbishments@gmail.com
            </p>
            <button
              data-testid="footer-quote-cta"
              onClick={() => scrollToId("quote")}
              className="mt-6 bg-[#c5832b] hover:bg-[#d9953c] text-[#121212] text-sm font-semibold px-6 py-3 rounded-[2px] transition-colors duration-300"
            >
              Request a quote
            </button>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#a3a3a3]/70">
            © {new Date().getFullYear()} Preece Refurbishments. Family owned & operated.
          </p>
          <button
            data-testid="footer-back-to-top"
            onClick={() => scrollToId("top")}
            className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#a3a3a3] hover:text-[#c5832b] transition-colors duration-300"
            aria-label="Back to top"
          >
            Back to top <ArrowUp size={14} />
          </button>
        </div>
      </div>
    </footer>
  );
}
